import BaseService from "./BaseService.js";

class DocumentsService extends BaseService {
    // needs to adapt to the backend
    get(query) {
        return this.apiGet({
            url: "/documents",
            params: query
        });
    }

    // needs to adapt to the backend
    getData(query) {
        return this.apiGet({
            url: "/document/data",
            params: query
        });
    }

    getLinking(query) {
        return this.apiGet({
            url: "/document/linking",
            params: query
        });
    }

    // needs to adapt to the backend
    submit(payload) {
        if (payload.id) {
            const { id, ...data } = payload;
            return this.apiPut({
                url: `/document/${id}`,
                data,
            });
        }
        return this.apiPost({
            url: "/document",
            data: payload,
        });
    }

    publish(id) {
        return this.apiPost({
            url: `/document/${id}/publish`,
        });
    }

    remove(id, data) {
        return this.apiDelete({
            url: `/document/${id}/remove`,
            data: data,
        });
    }
}

export default new DocumentsService();
